import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Plus, Trash2, Save } from 'lucide-react';
import { api } from '../lib/api';
import { useToast } from '../components/Toast';

export default function EmergencyGeo() {
  const toast = useToast();
  const { data: server = [] } = useQuery({ queryKey: ['emer-geo'], queryFn: () => api.emergencyGeo.list() });
  const [list, setList] = useState<any[]>([]);
  useEffect(() => { setList(server as any[]); }, [server]);

  function add() {
    setList([...list, { label: '', civic_address: '', network_match: [], mac_match: [], extension_match: [], is_default: false }]);
  }
  function update(i: number, patch: any) {
    setList(list.map((l, j) => j === i ? { ...l, ...patch } : l));
  }
  function arrField(i: number, key: string, value: string) {
    update(i, { [key]: value.split(',').map((s) => s.trim()).filter(Boolean) });
  }
  async function save() {
    try { await api.emergencyGeo.replace(list); toast('success', 'Saved'); }
    catch (e: any) { toast('error', e.message); }
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Emergency Geolocations (E911)</h1>
        <div className="space-x-2">
          <button onClick={add} className="btn-ghost inline-flex items-center gap-2"><Plus size={14} /> Add</button>
          <button onClick={save} className="btn-primary inline-flex items-center gap-2"><Save size={14} /> Save All</button>
        </div>
      </div>
      <p className="text-sm text-textSecondary">Civic address per network/MAC/extension. The location matched at call time is sent on 911. Required by Kari's Law / Ray Baum's Act.</p>
      <div className="space-y-2">
        {list.map((loc, i) => (
          <div key={i} className="card space-y-2">
            <div className="grid grid-cols-2 gap-2">
              <input className="input" placeholder="Label (HQ, branch-1, ...)" value={loc.label || ''} onChange={(e) => update(i, { label: e.target.value })} />
              <label className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked={!!loc.is_default} onChange={(e) => update(i, { is_default: e.target.checked })} />
                Default location
              </label>
            </div>
            <input className="input" placeholder="Civic address (street, suite, city, state, zip)" value={loc.civic_address || ''} onChange={(e) => update(i, { civic_address: e.target.value })} />
            <div className="grid grid-cols-3 gap-2">
              <input className="input font-mono text-xs" placeholder="Lat" value={loc.latitude || ''} onChange={(e) => update(i, { latitude: parseFloat(e.target.value) || null })} />
              <input className="input font-mono text-xs" placeholder="Lng" value={loc.longitude || ''} onChange={(e) => update(i, { longitude: parseFloat(e.target.value) || null })} />
              <button onClick={() => setList(list.filter((_, j) => j !== i))} className="btn-ghost text-danger inline-flex items-center justify-center"><Trash2 size={14} /></button>
            </div>
            <div className="grid grid-cols-3 gap-2">
              <input className="input font-mono text-xs" placeholder="Networks (CIDRs, comma-sep)"
                value={(loc.network_match || []).join(', ')} onChange={(e) => arrField(i, 'network_match', e.target.value)} />
              <input className="input font-mono text-xs" placeholder="MACs (comma-sep)"
                value={(loc.mac_match || []).join(', ')} onChange={(e) => arrField(i, 'mac_match', e.target.value)} />
              <input className="input font-mono text-xs" placeholder="Extensions (comma-sep)"
                value={(loc.extension_match || []).join(', ')} onChange={(e) => arrField(i, 'extension_match', e.target.value)} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
